// react
// dependencies
import { List, Map, fromJS } from "immutable";
import moment from "moment";
import PropTypes from "prop-types";
import React from "react";
import { connect } from "react-redux";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import { LoadingBar } from "@performyard/py-components";

// components
import Button from "../../../components/Button";
import Checkbox from "../../../components/Inputs/Checkbox";
import DatePicker from "../../../components/Inputs/DatePicker";
import TextInput from "../../../components/Inputs/TextInput";
import Link from "../../../components/Link";
import OptionsDrawer from "../../../components/OptionsDrawer";
import Tabs from "../../../components/Tabs";
// config
import Config from "./Config";
import AddForm from "./components/AddEasyAdd/addForm";
import AddFormToCycle from "./components/AddFormToCycle";

import { DisplayConfirmationModal } from "../../../actions/modals.actions";
// actions
import { StateChange } from "../../../actions/page.actions";
import {
	EditCycle,
	GetCycle,
	OpenSocket,
	changeBulkEditInput,
	deleteFormsFromCycle,
	init,
	resetBulkUpdateForm,
	selectFormForBulkEditing,
	sendBulkUpdatesToServer,
	toggleBulkEditGroup,
} from "./actions";

import { getUserHasObjectPermission } from "../../../selectors/permissions";
// selectors
import { getIsRequesting } from "../../../selectors/requests";
import { getAllReviewCycleForms } from "../../../selectors/reviewCycles";
import { getCompanySettingsContext } from "../../../selectors/settings";
import {
	getBulkEditGroupState,
	getBulkEditInputValue,
	getBulkEditingForm,
	getFormLastStartDate,
	getSelectedFormName,
} from "./selectors";

import Cookies from "../../../utils/Cookies";

// styles
import css from "./editReviewCycle.module.scss";

export class EditReviewCyclePage extends React.Component {
	/*
        The Edit page is going to use components from the create page.
    */

	static propTypes = {
		bulkInputVisibleToSubject: PropTypes.bool,
		bulkInputRedactAuthors: PropTypes.bool,
		cycleID: PropTypes.string,
		bulkEditingForm: PropTypes.string,
		bulkFormName: PropTypes.string,
		isBulkUpdating: PropTypes.bool.isRequired,
		canUserChangeRedactedness: PropTypes.bool.isRequired,
		showDueDateGroup: PropTypes.bool.isRequired,
		showVisibilityGroup: PropTypes.bool.isRequired,
		reviewCycleHasStarted: PropTypes.bool.isRequired,
		showRedactAuthorGroup: PropTypes.bool.isRequired,
		init: PropTypes.func.isRequired,
		getCycle: PropTypes.func.isRequired,
		editCycle: PropTypes.func.isRequired,
		changeState: PropTypes.func.isRequired,
		selectFormForBulkEditing: PropTypes.func.isRequired,
		toggleBulkEditGroup: PropTypes.func.isRequired,
		sendBulkUpdatesToServer: PropTypes.func.isRequired,
		deleteFormsFromCycle: PropTypes.func.isRequired,
		resetBulkUpdateForm: PropTypes.func.isRequired,
		changeBulkEditInput: PropTypes.func.isRequired,
		formValues: PropTypes.instanceOf(Map),
		reviewCycleName: PropTypes.string.isRequired,
		reviewCycleStartDate: PropTypes.instanceOf(moment),
		bulkFormLastStartDate: PropTypes.instanceOf(moment),
		allForms: PropTypes.instanceOf(Map).isRequired,
		bulkInputDueDateAuthors: PropTypes.oneOfType([PropTypes.instanceOf(moment), PropTypes.string]),
		bulkInputDueDateSigners: PropTypes.oneOfType([PropTypes.instanceOf(moment), PropTypes.string]),
		displayModal: PropTypes.func.isRequired,
		isBuilding: PropTypes.bool.isRequired,
		buildProgress: PropTypes.number.isRequired,
		reviewCycle: PropTypes.instanceOf(Map),
		openSocket: PropTypes.func.isRequired,
		reviewCycleIsActive: PropTypes.bool.isRequired,
		companySettings: PropTypes.instanceOf(Map).isRequired,
	};

	static defaultProps = {
		cycleID: null,
		bulkEditingForm: null,
		bulkInputRedactAuthors: null,
		bulkInputVisibleToSubject: null,
		reviewCycleStartDate: null,
		bulkFormName: null,
		bulkFormLastStartDate: null,
		bulkInputDueDateAuthors: null,
		bulkInputDueDateSigners: null,
		formValues: Map(),
		reviewCycle: Map(),
	};

	state = {
		editingName: null,
		editingStartDate: null,
		easyAddForms: fromJS([]),
		editingEasyAddFormList: [],
		replace: false,
		formToReplace: null,
		active: "basic",
		duplicateEasyAdd: false,
	};

	constructor(props) {
		super(props);
		props.getCycle(props.cycleID);
	}

	componentDidMount() {
		this.loadForms();
	}

	setActive = (val) => {
		this.setState({ active: val });
	};

	loadForms = async () => {
		await this.props.init();
	};

	handleUpdate = () => {
		const { formValues } = this.props;

		const update = {
			cycleName: formValues.get("cyclename"),
			startDate: formValues.get("startdate").toISOString(),
		};

		this.props.editCycle(this.props.cycleID, update);
	};

	saveUpdate = (updateNames) => {
		const update = {};

		for (const updateName of updateNames) {
			if (updateName === "editingName") {
				update.cycleName = this.state.editingName;
				this.setState({ editingName: null });
			} else if (updateName === "editingStartDate") {
				update.startDate = this.state.editingStartDate.toISOString();
				update.timezone = Cookies.get("_tz", Intl.DateTimeFormat().resolvedOptions().timeZone);
				this.setState({ editingStartDate: null });
			}
		}

		this.props.editCycle(this.props.cycleID, update);
	};

	handleChange = (name, value) => {
		this.props.changeState(["inputs", name], value);
	};

	handleOptionSelection = (item, baseFormID, formName) => {
		switch (item.id) {
			case "replace-form": {
				this.setState({ replace: true });
				this.setState({
					formToReplace: { baseFormID, name: formName },
				});
				break;
			}

			case "delete-form": {
				this.props.deleteFormsFromCycle(baseFormID, formName);
				break;
			}

			case "edit-form": {
				this.handleSelectCycleForm(formName);
				break;
			}

			default:
				break;
		}
	};

	cancelReplace = () => {
		if (this.state.replace === true) {
			this.setState({ replace: false });
		}
	};

	handleSelectCycleForm = (formIdentifier) => {
		this.props.selectFormForBulkEditing(formIdentifier);
	};

	handleBulkEditInputChange = (name, value) => {
		this.props.changeBulkEditInput(name, value);
	};

	turnOnEditing = (name, value) => {
		if (!this.state[name]) {
			this.setState({ [name]: value });
		}
	};

	turnOffEditing = (name) => {
		this.setState({ [name]: null });
	};

	render() {
		const {
			allForms,
			cycleID,
			bulkFormName,
			isBulkUpdating,
			reviewCycleName,
			bulkEditingForm,
			showDueDateGroup,
			showVisibilityGroup,
			reviewCycleStartDate,
			reviewCycleHasStarted,
			showRedactAuthorGroup,
			bulkFormLastStartDate,
			bulkInputRedactAuthors,
			bulkInputDueDateAuthors,
			bulkInputDueDateSigners,
			bulkInputVisibleToSubject,
			canUserChangeRedactedness,
			isBuilding,
			buildProgress,
			companySettings,
		} = this.props;

		const basicForms = allForms.get("basicForms", List());
		const easyAddForms = allForms.get("easyAddForms", List());
		const externalForms = allForms.get("externalForms", List());

		const { editingName, editingStartDate, replace, formToReplace, active } = this.state;

		// some checks from the acceptance criteria
		const isEditingBothDueDates =
			showDueDateGroup && moment.isMoment(bulkInputDueDateSigners) && moment.isMoment(bulkInputDueDateAuthors);
		const isSignerDateAfterAuthorDate =
			isEditingBothDueDates && bulkInputDueDateSigners.isSameOrAfter(bulkInputDueDateAuthors);
		const isDueDatesGreaterThanLastStartDate =
			bulkFormLastStartDate &&
			isEditingBothDueDates &&
			bulkInputDueDateSigners.isAfter(bulkFormLastStartDate) &&
			bulkInputDueDateAuthors.isAfter(bulkFormLastStartDate);

		let easyAddEnabled = null;
		let ff360Review = false;
		let defaultReviewCycleDueTime = 17;
		if (companySettings) {
			ff360Review = companySettings.getIn(["feature_flags", "ff-is-three-sixty-reviews-enabled"], false);
			easyAddEnabled = companySettings.getIn(["reviews", "easy_add"], null) && ff360Review;
			defaultReviewCycleDueTime = companySettings.getIn(["reviews", "default_review_cycle_due_time"], 17);
		}

		let tabTitles = [
			{
				id: "basic",
				label: "Forms",
				size: basicForms.size,
			},
			{
				id: "easyAdd",
				label: "360 Forms",
				size: easyAddForms.size,
			},
			{
				id: "external",
				label: "External Forms",
				size: externalForms.size,
			},
		];

		const activeBasicOrExternalForms = active === "basic" ? basicForms : externalForms;

		// remove easy add tab title if not enabled
		if (!easyAddEnabled) {
			tabTitles = tabTitles.filter((title) => title.id !== "easyAdd");
		}

		return (
			<div data-testid="editReviewCyclePage" style={{ paddingTop: Config.formVerticalMargin }}>
				<div
					className={css.createReviewCycleContainer}
					style={{ margin: `0 ${Config.formHorizontalMargin}px` }}
				>
					<div className={css.topControls}>
						<div className={css.backButtonWrapper}>
							<Link href={`/review-cycle/${cycleID}/`} className={css.backButton}>
								<div>
									<div className={css.backIcon}>
										<FontAwesomeIcon icon={["fas", "arrow-left"]} />
									</div>
									<div className={css.backLabel}>Back to Review Cycle</div>
								</div>
							</Link>
						</div>
					</div>

					<div className={css.reviewCycleAttributes}>
						<div className={css.cycleAttributeContainer}>
							<div className={css.label}>Review Cycle Name</div>
							<div
								data-testid="reviewCycleNameContainer"
								className={`${css.attributeValueContainer} ${css.isEditable}`}
								onClick={() => this.turnOnEditing("editingName", reviewCycleName)}
							>
								{editingName ? (
									<div>
										<TextInput
											value={editingName}
											onChange={(value) =>
												this.setState({
													editingName: value,
												})
											}
										/>
										<div className={css.buttons}>
											<Button
												className={css.button}
												color="green"
												onClick={() => this.saveUpdate(["editingName"])}
											>
												Save
											</Button>
										</div>
									</div>
								) : (
									<div className={css.attributeValue}>{reviewCycleName}</div>
								)}

								{editingName ? null : (
									<div data-testid="editNameIcon" className={css.editButton}>
										<FontAwesomeIcon icon={["fas", "pencil"]} />
									</div>
								)}
							</div>
						</div>

						{reviewCycleStartDate ? (
							<div className={css.cycleAttributeContainer}>
								<div className={css.label}>Review Cycle Start Date</div>
								<div
									data-testid="reviewCycleStartDateContainer"
									className={`${css.attributeValueContainer} ${
										reviewCycleHasStarted ? "" : css.isEditable
									}`}
									onClick={() =>
										reviewCycleHasStarted
											? null
											: this.turnOnEditing("editingStartDate", reviewCycleStartDate)
									}
								>
									{editingStartDate ? (
										<div>
											<DatePicker
												dateEngine="moment"
												hasTime={true}
												onChange={(value) =>
													this.setState({
														editingStartDate: value,
													})
												}
												value={editingStartDate}
											/>
											<div className={css.buttons}>
												<Button
													className={css.button}
													color="green"
													onClick={() => this.saveUpdate(["editingStartDate"])}
												>
													Save
												</Button>
												<Button
													className={css.button}
													color="grey"
													onClick={() => this.turnOffEditing("editingStartDate")}
												>
													Cancel
												</Button>
											</div>
										</div>
									) : (
										<div className={css.attributeValue}>
											{reviewCycleStartDate.format("MMM D, YYYY h:mm a")}
										</div>
									)}

									{reviewCycleHasStarted || editingStartDate ? null : (
										<div className={css.editButton} data-testid="editStartDateIcon">
											<FontAwesomeIcon icon={["fas", "pencil"]} />
										</div>
									)}
								</div>
							</div>
						) : null}
					</div>

					{isBuilding ? (
						<section className="review-cycle-view-page-container" style={{}}>
							<div className="is-loading-container">
								<section>
									<div className="loading-title">Updating Review Cycle</div>
									<div className="loading-subtitle">
										Please be patient while we update your review cycle.
									</div>
								</section>

								<div className="progress-bar-container">
									<div style={{ width: 500 }}>
										<LoadingBar
											value={buildProgress > 0 ? buildProgress : 35}
											timeToComplete={3500}
											initialProgress={0}
										/>
									</div>
								</div>
							</div>
						</section>
					) : (
						<div className={css.mainBulkEditFormComponent}>
							<Tabs activeTitle={active} titles={tabTitles} onSelectTitle={this.setActive} />
							{active === "basic" || active === "external" ? (
								<div>
									{activeBasicOrExternalForms.size > 0 && !bulkEditingForm ? (
										<div data-testid="reviewCycleForms" className={css.reviewCycleFormsList}>
											{activeBasicOrExternalForms.map((form) => {
												const formName = form.get("name", "");
												const formIdentifier = form.get("base_form_id", null);

												return (
													<div
														data-testid="reviewCycleForm"
														key={formIdentifier}
														className={css.cycleForm}
													>
														<div
															data-testid="optionsButton"
															onClick={(event) => event.stopPropagation()}
															className={css.optionsButton}
														>
															<OptionsDrawer
																options={
																	reviewCycleHasStarted
																		? [
																				{
																					id: "edit-form",
																					label: "Edit Form",
																				},
																				{
																					id: "delete-form",
																					label: "Delete Form",
																				},
																			]
																		: [
																				{
																					id: "edit-form",
																					label: "Edit Form",
																				},
																				{
																					id: "delete-form",
																					label: "Delete Form",
																				},
																				{
																					id: "replace-form",
																					label: "Replace Form",
																				},
																			]
																}
																onSelect={(item) =>
																	this.handleOptionSelection(
																		item,
																		formIdentifier,
																		formName
																	)
																}
															/>
														</div>
														<div>
															<div className={css.formLabel}>Form Name</div>
															<div data-testid="formName" className={css.formName}>
																{formName}
															</div>

															<div className={css.formLabel}>Form Count</div>
															<div data-testid="formCount">{form.get("count", 0)}</div>
														</div>
													</div>
												);
											})}
										</div>
									) : null}

									{bulkEditingForm ? (
										<div className={css.bulkEditFormContainer}>
											<div className={css.selectedForm}>
												<div>
													You are editing the form:{" "}
													<span className={css.bold}>{bulkFormName}</span>.
												</div>
												{active === "basic" && bulkFormLastStartDate ? (
													<div>
														The latest review start date is:{" "}
														<span className={css.bold}>
															{bulkFormLastStartDate.format("MMM D, YYYY h:mm a")}
														</span>
													</div>
												) : null}
											</div>

											<div className={css.bulkEditForm}>
												{active === "basic" ? (
													<div
														className={`${css.inputGroup} ${
															showDueDateGroup ? css.isOpen : ""
														}`}
													>
														<div
															onClick={() =>
																this.props.toggleBulkEditGroup("showDueDateGroup")
															}
															className={css.groupLabelContainer}
														>
															<div>
																<Checkbox
																	value={showDueDateGroup}
																	onChange={() => {}}
																/>
																<div className={css.groupLabel}>
																	Would you like to change due dates?
																</div>
															</div>
														</div>

														{showDueDateGroup ? (
															<div className={css.groupInputsWrapper}>
																<div className={css.groupInputs}>
																	<div>
																		{isEditingBothDueDates ? null : (
																			<div className={css.errorMessage}>
																				You must edit both due dates
																				simultaneously.
																			</div>
																		)}
																		{isEditingBothDueDates &&
																		!isSignerDateAfterAuthorDate ? (
																			<div className={css.errorMessage}>
																				{
																					"Signer due date can't be before the Author due date."
																				}
																			</div>
																		) : null}
																		{isEditingBothDueDates &&
																		!isDueDatesGreaterThanLastStartDate ? (
																			<div className={css.errorMessage}>
																				{
																					"Author and Signer due dates can't be before the latest start date of a review in the cycle."
																				}
																			</div>
																		) : null}

																		<div className={css.inputContainer}>
																			<div className={css.inputLabel}>
																				Due date for Authors
																			</div>
																			<DatePicker
																				dateEngine="moment"
																				hasTime={true}
																				defaultTime={defaultReviewCycleDueTime}
																				value={bulkInputDueDateAuthors}
																				onChange={(value) =>
																					this.handleBulkEditInputChange(
																						"authorsDueDate",
																						value
																					)
																				}
																			/>
																		</div>

																		<div className={css.inputContainer}>
																			<div className={css.inputLabel}>
																				Due date for Signers
																			</div>
																			<DatePicker
																				dateEngine="moment"
																				hasTime={true}
																				defaultTime={defaultReviewCycleDueTime}
																				value={bulkInputDueDateSigners}
																				onChange={(value) =>
																					this.handleBulkEditInputChange(
																						"signersDueDate",
																						value
																					)
																				}
																			/>
																		</div>
																	</div>
																</div>
															</div>
														) : null}
													</div>
												) : null}

												<div
													className={`${css.inputGroup} ${
														showVisibilityGroup ? css.isOpen : ""
													}`}
												>
													<div
														onClick={() =>
															this.props.toggleBulkEditGroup("showVisibilityGroup")
														}
														className={css.groupLabelContainer}
													>
														<div>
															<Checkbox value={showVisibilityGroup} />
															<div data-testid="authorVis" className={css.groupLabel}>
																Would you like to change the visibility setting?
															</div>
														</div>
													</div>

													{showVisibilityGroup ? (
														<div className={css.groupInputsWrapper}>
															<div className={css.groupInputs}>
																<div>
																	<div
																		data-testid="changeAuthorVis"
																		className={css.inputContainer}
																	>
																		<Checkbox
																			className={css.inputCheckbox}
																			value={bulkInputVisibleToSubject}
																			onChange={(value) =>
																				this.handleBulkEditInputChange(
																					"visible",
																					value
																				)
																			}
																		/>
																		<div
																			className={`${css.inputLabel} ${css.checkboxLabel}`}
																		>
																			Is visible to the subject (when all
																			Authors/Signers are finished)
																		</div>
																	</div>
																</div>
															</div>
														</div>
													) : null}
												</div>

												{canUserChangeRedactedness ? (
													<div
														className={`${css.inputGroup} ${
															showRedactAuthorGroup ? css.isOpen : ""
														}`}
													>
														<div
															onClick={() =>
																this.props.toggleBulkEditGroup("showRedactAuthorGroup")
															}
															className={css.groupLabelContainer}
														>
															<div>
																<Checkbox value={showRedactAuthorGroup} />
																<div className={css.groupLabel}>
																	Would you like to change the redact Author setting?
																</div>
															</div>
														</div>

														{showRedactAuthorGroup ? (
															<div className={css.groupInputsWrapper}>
																<div className={css.groupInputs}>
																	<div>
																		<div className={css.inputContainer}>
																			<Checkbox
																				className={css.inputCheckbox}
																				value={bulkInputRedactAuthors}
																				onChange={(value) =>
																					this.handleBulkEditInputChange(
																						"redacted",
																						value
																					)
																				}
																			/>
																			<div
																				className={`${css.inputLabel} ${css.checkboxLabel}`}
																			>
																				Redact Author(s)
																			</div>
																		</div>
																	</div>
																</div>
															</div>
														) : null}
													</div>
												) : null}
											</div>

											<div className={css.bulkButtonWrapper}>
												<Button
													color="grey"
													onClick={this.props.resetBulkUpdateForm}
													className={css.cancelBulkUpdateButton}
												>
													Cancel
												</Button>
												<Button
													isRequesting={isBulkUpdating}
													onClick={this.props.sendBulkUpdatesToServer}
													className={css.bulkUpdateButton}
												>
													Bulk Update
												</Button>
											</div>
										</div>
									) : null}
									<div data-testid="addFormButton">
										<AddFormToCycle
											formType={active}
											config={Config}
											canUserChangeRedactedness={canUserChangeRedactedness}
											replace={replace}
											formtoReplace={formToReplace}
											cancelReplace={() => this.cancelReplace()}
											{...this.state}
										/>
									</div>
								</div>
							) : null}

							{active === "easyAdd" ? (
								<AddForm
									startDate={this.props.reviewCycleStartDate}
									canUserChangeRedactedness={canUserChangeRedactedness}
									ff360Review={ff360Review}
								/>
							) : null}
						</div>
					)}
				</div>
			</div>
		);
	}
}

const mapStateToProps = (state) => {
	const cycleID = state.navigation.getIn(["page", "values", "cycleId"]);
	const reviewCycle = state.reviews.getIn(["cycles", cycleID], Map());
	return {
		cycleID,
		reviewCycleName: reviewCycle.get("name", ""),
		reviewCycleHasStarted: reviewCycle.get("hasStarted", true),
		reviewCycleStartDate: reviewCycle.get("startDate", moment()),
		reviewCycleIsActive: !reviewCycle.get("isClosing", null),
		bulkEditingForm: getBulkEditingForm(state),
		allForms: getAllReviewCycleForms(state, cycleID),
		formValues: state.page.getIn([Config.pageName, "inputs"]),
		appHeight: state.app.getIn(["appMeasurements", "height"]),
		showDueDateGroup: getBulkEditGroupState(state, "showDueDateGroup"),
		showVisibilityGroup: getBulkEditGroupState(state, "showVisibilityGroup"),
		showRedactAuthorGroup: getBulkEditGroupState(state, "showRedactAuthorGroup"),
		bulkInputRedactAuthors: getBulkEditInputValue(state, "redacted"),
		bulkInputDueDateAuthors: getBulkEditInputValue(state, "authorsDueDate"),
		bulkInputDueDateSigners: getBulkEditInputValue(state, "signersDueDate"),
		bulkInputVisibleToSubject: getBulkEditInputValue(state, "visible"),
		isBulkUpdating: getIsRequesting(state, "REVIEWCYCLE:BULKUPDATE"),
		bulkFormLastStartDate: getFormLastStartDate(state, null),
		bulkFormName: getSelectedFormName(state, null),
		canUserChangeRedactedness: getUserHasObjectPermission(
			state,
			"reviewCycles",
			cycleID,
			"edit-cycle-forms-redactedness"
		),
		isBuilding: state.page.getIn([Config.pageName, "isBuilding"], false),
		buildProgress: state.page.getIn([Config.pageName, "buildProgress"], 0),
		reviewCycle: state.reviews.getIn(["cycles", cycleID]),
		companySettings: getCompanySettingsContext(state),
	};
};

const mapDispatchToProps = (dispatch) => ({
	init: () => dispatch(init()),
	resetBulkUpdateForm: () => dispatch(resetBulkUpdateForm()),
	openSocket: (cycleID) => dispatch(OpenSocket(cycleID)),
	getCycle: (cycleId) => dispatch(GetCycle(cycleId)),
	sendBulkUpdatesToServer: () => dispatch(sendBulkUpdatesToServer()),
	deleteFormsFromCycle: (baseFormID, formName) => dispatch(deleteFormsFromCycle(baseFormID, formName)),
	toggleBulkEditGroup: (groupName) => dispatch(toggleBulkEditGroup(groupName)),
	editCycle: (cycleId, payload) => dispatch(EditCycle(cycleId, payload)),
	changeBulkEditInput: (name, value) => dispatch(changeBulkEditInput(name, value)),
	selectFormForBulkEditing: (formIdentifer) => dispatch(selectFormForBulkEditing(formIdentifer)),
	changeState: (keyPath, value) => dispatch(StateChange(Config.pageName, keyPath, value)),
	displayModal: (message, action) => dispatch(DisplayConfirmationModal(message, action)),
});

export default connect(mapStateToProps, mapDispatchToProps)(EditReviewCyclePage);
